import { render } from "./QuestionPatientScreen.vue?vue&type=template&id=03daad86&scoped=true"
import script from "./QuestionPatientScreen.vue?vue&type=script&lang=js"
export * from "./QuestionPatientScreen.vue?vue&type=script&lang=js"

import "./QuestionPatientScreen.vue?vue&type=style&index=0&id=03daad86&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03daad86"]])

export default __exports__